
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'DirectionsWhatWeTransportBlock',

  computed: {
    sections: function () {
      return this.values?.items || []
    }
  }
});
